
export const CHANGE_PASSWORD_PAGE = 'change-password'; // S4
export const DASHBOARD_PAGE = 'dashboard'; // S5
export const MACHINE_INPUT_PAGE = 'machine-input'; //S6
export const REGISTER_INSPECTION_PAGE = 'inspections-register'; // S7
export const UPDATE_INSPECTION_PAGE = 'inspections-update'; // S8
export const JUDGMENT_PAGE = 'judgment'; //S9
export const MASTER_DASHBOARD_PAGE = 'master-dashboard'; // S10

export const SEARCH_PAGE = 'search'; // S12-13
export const SEARCH_MACHINES_PAGE = 'search-machines' // S14
export const SEARCH_INSPECTION_HISTORY_RESULT_PAGE = 'search-inspections-results'; // S15
export const UNFINISHED_ACTION_LIST_PAGE = 'unfinished-action-list'; // S16
export const TREATMENT_PAGE = 'treatment'; // S17
export const MY_PAGE_PAGE = 'my-page'; // S18
export const SETTING_PAGE = 'settings'; // S19
export const TEMPLATE_MANAGEMENT_PAGE = 'template-management'; // S20
export const INSPECTION_ITEM_EDIT_PAGE = 'inspection-item-edit'; // S21

// Machine Master page name
export const MACHINE_MASTER_DASHBOARD_PAGE = 'machines-dashboard'; // S22
export const MACHINE_MASTER_UPDATE_PAGE = 'machines-update'; // S23
export const MACHINE_MASTER_IMPORT_PAGE = 'machines-import'; // S24
export const MACHINE_MASTER_EXPORT_PAGE = 'machines-export'; // S25
export const MACHINE_MASTER_HISTORY_SEARCH_PAGE = 'machines-history-search'; // S26
export const MACHINE_MASTER_GROUP_UPDATE_PAGE = 'machines-group-update'; // S27

// Position Master
export const POSITION_MASTER_DASHBOARD_PAGE = "positions-dashboard"; // S29
export const POSITION_MASTER_UPDATE_PAGE = 'positions-update'; // S30
export const POSITION_MASTER_HISTORY_SEARCH_PAGE = 'positions-history-search'; // S31
export const POSITION_MASTER_IMPORT_PAGE = 'positions-import'; // S32
export const POSITION_MASTER_EXPORT_PAGE = 'positions-export'; // S33

// Department Mater
export const DEPARTMENT_MASTER_UPDATE_PAGE = "departments-update"; // S28
export const DEPARTMENT_MASTER_DASHBOARD_PAGE = "departments-dashboard"; // S34
export const DEPARTMENT_MASTER_HISTORY_SEARCH_PAGE = "departments-history-search"; // S35
export const DEPARTMENT_MASTER_IMPORT_PAGE = "departments-import"; // S36
export const DEPARTMENT_MASTER_EXPORT_PAGE = "departments-export"; // S37

export const INSPECTION_STATUS_PAGE = "inspections-status"; // S38
export const INSPECTION_SHEET_PAGE = "inspections-sheet"; // S39
export const SEARCH_INSPECTION_HISTORY_CONFIRM_PAGE = 'search-inspections-confirmation'; // S40
export const SEARCH_INSPECTION_HISTORY_CORRECTION_PAGE = 'search-inspections-correction'; // S41
export const SEARCH_TREATMENT_HISTORY_DETAIL_PAGE = 'search-treatment-details'; // S41

// Inspection Template page name
export const INSPECTION_TEMPLATE_MASTER_DASHBOARD_PAGE = '/inspection-template-dashboard'; // S42
export const INSPECTION_TEMPLATE_MASTER_SEARCH_PAGE = 'inspection-template-update-history-search'; //S43
export const INSPECTION_TEMPLATE_MASTER_IMPORT_PAGE = 'inspection-template-import'; // S44
export const INSPECTION_TEMPLATE_MASTER_EXPORT_PAGE = 'inspection-template-export'; // S45

// Approval Setting page name
export const APPROVAL_SETTING_MASTER_DASHBOARD_PAGE = 'approval-settings-dashboard'; // T3
export const APPROVAL_SETTING_PAGE = 'approval-settings'; // T1
export const APPROVAL_SETTING_DETAIL_PAGE = 'approval-settings-detail'; // T2
export const APPROVAL_SETTING_MASTER_SEARCH_PAGE = 'approval-settings-update-history-search'; // T4
export const APPROVAL_SETTING_MASTER_IMPORT_PAGE = 'approval-settings-import'; // T5
export const APPROVAL_SETTING_MASTER_EXPORT_PAGE = 'approval-settings-export'; // T6

// USER page name
export const USER_MASTER_TOP_PAGE = 'user-master-top'; // W1
export const USER_MASTER_EXPORT_PAGE = 'user-master-export'; // W2
export const USER_MASTER_UPDATE_PAGE = 'user-master-update'; // W3
export const USER_MASTER_IMPORT_PAGE = 'user-master-import'; // W4
export const USER_MASTER_HISTORY_SEARCH_PAGE = 'user-master-history-search'; // W5
export const USER_MASTER_SEARCH_PAGE = 'user-master-search'; // W6